export default "__VITE_ASSET__DeOQMRiO__"